import { useCallback } from 'react'
import type { GuideTourNotificationInteractionEvent } from '@/guide-tour/notifications/types'
import { useAnalyticsSellerContext } from '@/hooks/useAnalyticsSellerContext'
import { pathNameToSegmentScreenName } from '@/resources/utils/analytics'

import {
  mapGuideTourClickedProps,
  mapGuideTourViewedProps,
} from './analytics-mappers'
import { trackPracticeOrderEditGuideTourInteraction } from '../practiceOrderEditGuideTourAnalytics'

export const useGuideTourAnalytics = () => {
  const sellerContext = useAnalyticsSellerContext()

  const onGuideTourInteraction = useCallback(
    (event: GuideTourNotificationInteractionEvent) => {
      if (event.notificationItem) {
        return
      }

      if (trackPracticeOrderEditGuideTourInteraction(event)) {
        return
      }

      const screenName = pathNameToSegmentScreenName(event.pathname ?? null)

      switch (event.action) {
        case 'start':
          if (event.autoStart !== true) {
            return
          }

          sellerContext.guideTourViewed(
            {
              screen_name: screenName,
              ...mapGuideTourViewedProps(event),
            },
            { minimalContext: true }
          )
          break

        case 'next':
        case 'complete':
        case 'dismiss':
        case 'interrupt':
        case 'restart': {
          const componentName = event.componentName ?? event.action

          sellerContext.guideTourClicked(
            {
              screen_name: screenName,
              ...mapGuideTourClickedProps(event, componentName),
            },
            { minimalContext: true }
          )
          break
        }

        default:
          break
      }
    },
    [sellerContext]
  )

  return { onGuideTourInteraction }
}
